import cx from 'classnames';

const NavItem = ({ label, active, disabled, onClick }) => {
  return (
    <li className={cx('nav-item', { active, disabled })} aria-selected={active} role="tab" onClick={onClick}>
      <span>{label}</span>
    </li>
  );
};

export default NavItem;
